var storage_data = {}

export function loadStorageData () {
  if (localStorage.getItem('vibe-webrtc')) {
    storage_data = JSON.parse(localStorage.getItem('vibe-webrtc'))
  }
}

export function saveLocalStorage () {
  localStorage.setItem('vibe-webrtc', JSON.stringify(storage_data))
}

export function saveMetaToken (token) {
  localStorage.setItem('meta_renewal', token)
}

export function getMetaToken () {
  return localStorage.getItem('meta_renewal')
}

export function removeMetaToken () {
  return localStorage.removeItem('meta_renewal')
}

export function getItem (item) {
  return storage_data[item]
}

export function saveCorenexaToken (token) {
  localStorage.setItem('corenexa_token', token)
}

export function getCorenexaToken () {
  return localStorage.getItem('corenexa_token')
}

export function saveJitsiToken (token) {
  localStorage.setItem('jitsi_token', token)
}

export function getJitsiToken () {
  return localStorage.getItem('jitsi_token')
}

export function removeJitsiToken () {
  return localStorage.removeItem('jitsi_token')
}

export function removeChatItems () {
  let chatItems = Object.keys(storage_data).filter( key => { if(key.match(/^[0-9]+$/) != null) { return key } })
  chatItems.forEach(item => delete storage_data[item])
  delete storage_data['public']
  saveLocalStorage()
}

export function setItem (name, value) {
  storage_data[name] = value
  saveLocalStorage()
}

export function isDebug (level) {
  return storage_data['debug'] === level
}



// WEBPACK FOOTER //
// ./src/functions/storageManager.js